export const base64ToKiloBytes = (base64String) => {
  const base64Data = base64String.split(',')[1];
  const decoded = atob(base64Data)
  const decodedBytes = Array.from(decoded);
  const fileSizeInBytes = decodedBytes.length;
  const fileSizeInKiloBytes = fileSizeInBytes / 1024;

  return fileSizeInKiloBytes;
}

export const calculateImageSize = (base64Data) => {
    const len = base64Data.split(',')[1].length;
    return len * 0.75; 
  };
  
  export const changeImageSize = async (base64, kiloBytes) => {
    const img = new Image();
    const desiredSize = kiloBytes * 1024;
  
    const loadImage = new Promise((resolve, reject) => {
      img.onload = () => resolve(img);
      img.onerror = reject;
    });
  
    img.src = base64;
    await loadImage;
  
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  
    let quality = 0.9;
    let base64Data = canvas.toDataURL('image/jpeg', quality);
    let size = calculateImageSize(base64Data);
  
    let minQuality = 0;
    let maxQuality = 1;
  
    while (Math.abs(size - desiredSize) > 100 && maxQuality - minQuality > 0.01) {
      if (size > desiredSize) {
        maxQuality = quality;
      } else {
        minQuality = quality;
      }
      quality = (minQuality + maxQuality) / 2;
      base64Data = canvas.toDataURL('image/jpeg', quality);
      size = calculateImageSize(base64Data);
    }
  
    return base64Data;
  };
  